import { Paper, Center, Loader, Text } from "@mantine/core";

import { ListWorkOrderDto } from "../../models/workorder.models";
import { useGetWorkOrdersByCategoryIdQuery } from "../../api/workorder.api";
import { WorkOrderListItem } from "../WorkOrders/WorkOrderListItem";

interface CategoryWorkOrderListProps {
	categoryId: string;
	onSelect?: (workOrder: ListWorkOrderDto) => void;
	selectedWorkOrderId?: string | null;
}

export const CategoryWorkOrderList = ({ categoryId, onSelect, selectedWorkOrderId }: CategoryWorkOrderListProps) => {
	const { data: workOrders, isLoading } = useGetWorkOrdersByCategoryIdQuery(categoryId);

	const sortedWorkOrders = workOrders?.sort((a, b) => new Date(b.Created).getTime() - new Date(a.Created).getTime()) || [];

	if (isLoading) return <>
		<Center>
			<Loader size="sm" mt="lg" />
		</Center>
	</>;

	if (!workOrders?.length) return <Text c="dimmed">No work orders for this category.</Text>;

	return (
		<Paper p={0} radius="md" style={{ overflow: 'hidden' }}>
			{sortedWorkOrders.map(workOrder => (
				<WorkOrderListItem
					key={workOrder.WorkOrderId}
					workOrder={workOrder}
					selected={selectedWorkOrderId === workOrder.WorkOrderId}
					onSelect={onSelect ? onSelect : () => { }}
					showLocation={true}
				/>
			))}
		</Paper>
	);
};
